var SCM = SCM || {};

(function (ns, $) {
    ns.init = function () {
        $('.js-google-preview-ref-link').show();
        $('.js-worldcat-preview-ref-link').show();
        $('.js-copac-preview-ref-link').show();
        ns.showParagraphCitations();
    };

    ns.showParagraphCitations = function () {
        var activeElement = undefined;
        var $siblings = undefined;
        $('.js-citation-links').off('click');
        $('.js-citation-links').on('click', function (e) {
            e.stopPropagation();
            activeElement = document.activeElement;
            $siblings = $(this).siblings('.citation-wrap');
            if ($siblings.is(':visible')) {
                $siblings.removeClass('show-inline').addClass('hidden');
            }
            else {
                // close any other open ones first
                $('.citation-wrap').removeClass('show-inline').addClass('hidden');
                $siblings.removeClass('hidden').addClass('show-inline');
                var $citationLinks = $siblings.find('.citation-links a:visible');
                if ($citationLinks.length) {
                    $citationLinks[0].focus();
                }
            }
        });
        $(document).on('click', function () {
            if ($siblings !== undefined) {
                $siblings.removeClass('show-inline').addClass('hidden');
                if (activeElement !== undefined) {
                    activeElement.focus();
                }
                $siblings = undefined;
            }
        });
    };
})(SCM.RefLinks = SCM.RefLinks || {}, jQuery);

